export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15118.b8f22513.jpg";